import WorkoutCalendar from './WorkoutCalendar';

export default WorkoutCalendar;
